<rt-spinner variant="small-x" />
<span class="label">{{ toolName() }}</span>
